document.addEventListener('DOMContentLoaded', () => {
  
});


function copyText(event, text) {
	const str = event.querySelector('.ip').innerHTML;
	const el = document.createElement("input");

	el.type = "text";
	event.appendChild(el);
	el.value = str;
	el.select();
	document.execCommand("copy");
	event.removeChild(el);

	snackbar(text);
}

function snackbar(text){
	const el = document.createElement("div");
	el.classList.add('snackbar');
	el.innerHTML = text;
	document.body.appendChild(el);

	setTimeout(()=> {
		el.classList.add('active');
	},10);

	setTimeout(()=> {
		document.body.removeChild(el);
	},3000);
}